import React, { useState, useEffect } from "react";
import { Typography, Button, Box, Chip } from "@mui/material";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonIcon from '@mui/icons-material/Person';
import NumberFormat from "react-number-format";
import { obtenerPresupuestosCGMesV } from "../../actions/PresupuestosAction";
import moment from "moment";
import { useStateValue } from "../../contexto/store";

export default function CerradosGanadosMesVendedor() {
  const [{ sesionUsuario }] = useStateValue();
  const [presupuestosTotal, setPresupuestosTotal] = useState([]);
  
  const actualizarTotales = () => {
    const desde = moment().startOf("month").format();
    const hasta = moment().endOf("month").format();
    const usuario = sesionUsuario.usuario.id;
    obtenerPresupuestosCGMesV(desde, hasta, usuario).then((response) => {
      const Data = response.data;
      setPresupuestosTotal(Data);
    });
  };

  useEffect(() => {
    const desde = moment().startOf("month").format();
    const hasta = moment().endOf("month").format();
    const usuario = sesionUsuario.usuario.id;
    obtenerPresupuestosCGMesV(desde, hasta, usuario).then((response) => {
      const Data = response.data;
      setPresupuestosTotal(Data);
    }); 
  }, [sesionUsuario]);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 0.5 }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1.5,
        mb: 2 
      }}>
        <Box sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #66bb6a 0%, #43a047 100%)',
          boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)'
        }}>
          <TrendingUpIcon sx={{ color: 'white', fontSize: 28 }} />
        </Box>
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <Chip 
            icon={<PersonIcon />}
            label={sesionUsuario.usuario?.nombrecompleto || ''}
            size="small"
            color="success"
            variant="outlined"
            sx={{ 
              fontSize: '0.7rem',
              height: 24,
              maxWidth: '100%',
              '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }}
          />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem', lineHeight: 1.2, mt: 0.5 }}>
            Ganados del Mes
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', mb: 2 }}>
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 800, 
            color: 'success.main',
            textAlign: 'left',
            fontSize: { xs: '1.75rem', sm: '2rem' }
          }}
        >
          <NumberFormat
            lang="es"
            notranslate="true"
            value={presupuestosTotal.total}
            displayType="text"
            thousandSeparator="."
            decimalSeparator={false}
            prefix="₲ "
          />
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Mis presupuestos cerrados con éxito
        </Typography>
      </Box>

      <Button 
        variant="outlined" 
        color="success"
        onClick={actualizarTotales}
        startIcon={<RefreshIcon />}
        size="small"
        sx={{ 
          borderRadius: 1.5,
          textTransform: 'none',
          fontWeight: 600,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: 'success.light',
            color: 'white'
          }
        }}
      >
        Actualizar
      </Button>
    </Box>
  );
}